<template>
  <base-icon
    :class="$style.container"
    name="info"
    v-tooltip="text"
    themeColor="icons"
  />
</template>

<script>
export default {
  name: 'base-info-tooltip',

  props: {
    text: { type: String, required: true }
  }
}
</script>

<style lang="scss" module>
.container {
  margin-top: -3px;
  cursor: help;
  outline: none;
}
</style>
